import React from 'react';
import { RouterProvider } from 'react-router-dom';

import { ClerkProvider } from '@clerk/clerk-react';

import { ErrorBoundary } from '@/components/error-boundary';

import ClerkTheme from './ClerkTheme.module.scss';

// import must come after ClerkTheme import for style overrides
import { router } from './router.jsx';

export default function App() {
	return (
		<div className={ClerkTheme.theme}>
			<ErrorBoundary>
				<ClerkProvider publishableKey={import.meta.env.VITE_CLERK_PUBLISHABLE_KEY}>
					<RouterProvider router={router} />
				</ClerkProvider>
			</ErrorBoundary>
		</div>
	);
}
